import React from 'react';
import './VideoModal.css';

const VideoModal = ({ videoPath, onClose }) => {
  return (
    <div className="video-modal-backdrop" onClick={onClose}>
      <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="video-modal-close-btn" onClick={onClose} title="Close">
          &times;
        </button>
        <video src={videoPath} controls autoPlay playsInline />
      </div>
    </div>
  );
};

export default VideoModal;